export default __webpack_public_path__ + "static/media/weekend.4c30cb7e.png";